import { GridRowGroupingModel, GridRowSelectionModel } from "@mui/x-data-grid-premium";

export function updateGroupedRowSelection(
    newSelectionModel: GridRowSelectionModel,
    previousSelectionModel: GridRowSelectionModel | undefined,
    rowGrouping: GridRowGroupingModel | undefined,
    allRows: any[]
): GridRowSelectionModel {
    if (!rowGrouping || rowGrouping.length == 0) {
        return newSelectionModel;
    }

    const resultingSelectionModel = newSelectionModel.slice(0);
    const oldSelectionModel = previousSelectionModel || [];
    const addedRows = newSelectionModel.filter(n => oldSelectionModel.indexOf(n) == -1);
    addedRows
        .filter(a => a.toString().startsWith("auto-generated-row"))
        .forEach(a => {
            // Process each grouped row added to the selection.
            const addedId = a.toString();
            const groups: { field: string, fieldIdx: number, value: string, valueIdx: number }[] = [];

            // Based on existing GridRowGrouping, parse the grouped column fields and values
            rowGrouping.forEach(grpng => {
                const groupStart = addedId.indexOf("-" + grpng + "/");
                if (groupStart > 0) {
                    groups.push({
                        field: grpng,
                        fieldIdx: groupStart,
                        value: addedId.slice(groupStart + grpng.length + 2),
                        valueIdx: groupStart + grpng.length + 2
                    });
                }
            });
            groups.forEach(grp => {
                const valueLength = groups
                    .filter(g => g.fieldIdx > grp.valueIdx)
                    .map(g => g.fieldIdx)
                    .reduce((acc, fieldIdx) => Math.min(acc, fieldIdx - grp.valueIdx), grp.value.length);
                grp.value = grp.value.slice(0, valueLength);
            })

            // Identify data rows that need to be added to selection
            let groupedRowsAdded: any = null;
            groups.forEach(grp => {
                groupedRowsAdded = (groupedRowsAdded as any[] || allRows)
                    .filter(t => {
                        return t[grp.field] == grp.value;
                    });
            });

            if (groupedRowsAdded) {
                (groupedRowsAdded as any[]).forEach(row => {
                    if (resultingSelectionModel.indexOf(row.shipmentID) == -1) {
                        // Add child data rows to selection
                        resultingSelectionModel.push(row.shipmentID);
                    }

                    if (groups.length < rowGrouping.length) {
                        const subgroupLevel = rowGrouping.length - groups.length;
                        let subGroupRow = "auto-generated-row";
                        rowGrouping.forEach((grpng, grpngIdx) => {
                            subGroupRow += "-" + grpng + "/" + row[grpng];
                            if (rowGrouping.length - grpngIdx <= subgroupLevel && resultingSelectionModel.indexOf(subGroupRow) == -1) {
                                // Add child grouped row to selection
                                resultingSelectionModel.push(subGroupRow);
                            }
                        })
                    }
                })
            }
        });

    const removedRows = oldSelectionModel.filter(o => newSelectionModel.indexOf(o) == -1);
    removedRows
        .filter(r => r.toString().startsWith("auto-generated-row"))
        .forEach(r => {
            // Process each grouped row removed from the selection.
            const removedId = r.toString();
            const groups: { field: string, fieldIdx: number, value: string, valueIdx: number }[] = [];

            // Based on existing GridRowGrouping, parse the grouped column fields and values            
            rowGrouping.forEach(grpng => {
                const groupStart = removedId.indexOf("-" + grpng + "/");
                if (groupStart > 0) {
                    groups.push({
                        field: grpng,
                        fieldIdx: groupStart,
                        value: removedId.slice(groupStart + grpng.length + 2),
                        valueIdx: groupStart + grpng.length + 2
                    });
                }
            });
            groups.forEach(grp => {
                const valueLength = groups
                    .filter(g => g.fieldIdx > grp.valueIdx)
                    .map(g => g.fieldIdx)
                    .reduce((acc, fieldIdx) => Math.min(acc, fieldIdx - grp.valueIdx), grp.value.length);
                grp.value = grp.value.slice(0, valueLength);
            })

            // Identify data rows that need to be removed from the selection
            let groupedRowsRemoved: any = null;
            groups.forEach(grp => {
                groupedRowsRemoved = (groupedRowsRemoved as any[] || allRows)
                    .filter(t => {
                        return t[grp.field] == grp.value;
                    });
            });

            if (groupedRowsRemoved) {
                (groupedRowsRemoved as any[]).forEach(row => {
                    const indexToRemove = resultingSelectionModel.indexOf(row.shipmentID);
                    if (indexToRemove >= 0) {
                        // Remove child data row from selection
                        resultingSelectionModel.splice(indexToRemove, 1);
                    }

                    if (groups.length < rowGrouping.length) {
                        const subgroupLevel = rowGrouping.length - groups.length;
                        let subGroupRow = "auto-generated-row";
                        rowGrouping.forEach((grpng, grpngIdx) => {
                            subGroupRow += "-" + grpng + "/" + row[grpng];
                            if (rowGrouping.length - grpngIdx <= subgroupLevel) {
                                const rowToRemove = resultingSelectionModel.indexOf(subGroupRow);
                                if (rowToRemove >= 0) {
                                    // Remove child grouped row from selection
                                    resultingSelectionModel.splice(rowToRemove, 1);
                                }
                            }
                        })
                    }
                })
            }
        });

    return resultingSelectionModel;
} 